"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[43290],{

/***/ 217622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ SelectOption; }
/* harmony export */ });
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(173698);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46610);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getBorderColor = (props) => {
  var _a;
  return props.isActive && props.theme ? (_a = props.theme) == null ? void 0 : _a.brand.primary : "#e0e0e0";
};
const getColor = (props) => {
  return props.isActive && props.theme ? props.theme.brand.primary : "#333333";
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
  border-radius: 4px;
  display: inline-block;
  user-select: none;
  border: solid 1px ${getBorderColor(props)};
  background-color: ${props.activeBackground && props.isActive ? props.activeBackground : "#fff"};
  padding: 0.5rem 1.25rem;
  position: relative;
  overflow: hidden;
  cursor: ${props.isDisabled ? "default" : "pointer"};
  ${props.block ? "width: 100%;" : ""}

  &:hover {
    background: ${props.isActive || props.isDisabled ? "" : "#f3f3f3"} ;
  }
  `);
const Title = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
  color: ${props.activeBackground && props.isActive ? getColor(props) : ""};
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.875rem;
 `);
const ActiveBorder = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => {
  var _a;
  return `
  position: absolute;
  top: -1px;
  right: -1px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: ${props.stickySize === "sm" ? "0px 20px 20px 0px" : "0px 36px 36px 0px"};
  border-color: transparent ${(_a = props.theme) == null ? void 0 : _a.brand.primary} transparent transparent;
`;
});
const Checked = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span((props) => `
  position: absolute;
  top: ${props.stickySize === "sm" ? "-4px" : "0"};
  right: ${props.stickySize === "sm" ? "2px" : "6px"};
  color: #fff;
  z-index: 0;
  font-size: ${props.stickySize === "sm" ? "7px" : "10px"};
`);
const IconWrappper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  margin-left: 8px;
`;
const StyledTag = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Tag */ .V)`
  margin-left: 8px;
`;
const SubTitle = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.p */ .z.p`
  margin-bottom: 0.5rem;
  color: #848788;
`;
const Overlay = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #d8d8d852;
  z-index: 1;
`;
const SelectOption = (_a) => {
  var _b = _a, {
    title,
    subTitle,
    children,
    icon,
    tag,
    isActive,
    onClickOption,
    onClickIcon,
    onMouseEnter,
    activeBackground,
    stickySize,
    isDisabled,
    tags
  } = _b, props = __objRest(_b, [
    "title",
    "subTitle",
    "children",
    "icon",
    "tag",
    "isActive",
    "onClickOption",
    "onClickIcon",
    "onMouseEnter",
    "activeBackground",
    "stickySize",
    "isDisabled",
    "tags"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    activeBackground,
    isActive: !isDisabled && isActive,
    onClick: (ev) => !isDisabled && (onClickOption == null ? void 0 : onClickOption(ev)),
    onMouseEnter,
    isDisabled
  }, props), isDisabled && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Overlay, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, {
    activeBackground,
    isActive: !isDisabled && isActive
  }, title, " ", tag && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTag, __spreadValues({}, tag)), " ", ((tags == null ? void 0 : tags.length) || 0) > 0 && (tags == null ? void 0 : tags.map((value) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTag, __spreadValues({
    key: String(value.children)
  }, value)))), icon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconWrappper, {
    onClick: onClickIcon
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l, __spreadValues({}, icon)))), subTitle && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SubTitle, null, subTitle), children, !isDisabled && isActive && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ActiveBorder, {
    stickySize
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Checked, {
    stickySize
  }, "\u2713")));
};




/***/ }),

/***/ 469381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Promotion; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(526439);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(179185);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46610);
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23212);
/* harmony import */ var _Common_SelectOption_SelectOption_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(217622);
/* harmony import */ var _PromotionInfo_PromotionInfo_es_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(468382);







const Quantity = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  font-size: 0.75rem;
  color: #848788;
  margin-right: 4px;
`;
const Content = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: flex;
  justify-content: space-around;
`;
const Benefit = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const Expired = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  font-size: 0.75rem;
  color: #f78212;
  margin-left: 8px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 6px;
`;
const Label = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  font-size: 0.75rem;
  color: #333333;
  flex: 1;
`;
const Coupon = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  text-transform: uppercase;
  padding: 0 6px;
  margin: 0 4px;
  background-color: #ef2741;
  color: #fff;
  border-radius: 2px;
  display: inline-block;
`;
const GiftImage = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  width: 10%;
  margin-right: 12px;
`;
const Discount = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Currency */ .F)`
  color: #ed2101;
  margin-left: 4px;
`;
const StyledPrice = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(Discount)`
  font-weight: bold;
`;
const PriceWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
const GiftWrapper = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(PriceWrapper)`
  margin-top: 8px;
`;
const PromotionIcon = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  width: 10%;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
  margin-right: 12px;
`;
const Price = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.strong */ .z.strong`
  color: #ed2101;
`;
const Promotion = ({
  promotion,
  className,
  active = false,
  onClick
}) => {
  var _a, _b;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_SelectOption_SelectOption_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SelectOption */ .$, {
    isActive: active,
    activeBackground: "rgba(20, 53, 195, 0.08)",
    onClickOption: () => onClick(promotion.id),
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Benefit, null, promotion.price && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PriceWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Price, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Gi\xE1:")), " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPrice, {
    value: promotion.price
  })), promotion.type === _types_es_js__WEBPACK_IMPORTED_MODULE_5__/* .PromotionType.PRODUCT */ .q.PRODUCT ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, promotion.benefit.money && !!promotion.benefit.money && promotion.benefit.money.map((moneyPromotion) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    key: moneyPromotion.id
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("\u0110\xE3 gi\u1EA3m th\xEAm"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Discount, {
    value: moneyPromotion.money || 0
  }))), promotion.benefit.items && !!promotion.benefit.items && promotion.benefit.items.map((gift) => {
    var _a2;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GiftWrapper, {
      key: gift.name
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GiftImage, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .LazyImage */ .w, {
      borderRadius: 2,
      contain: true,
      src: ((_a2 = gift.image) == null ? void 0 : _a2.src) || ""
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Quantity, null, "x", gift.quantity), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, null, gift.name));
  })) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GiftWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PromotionIcon, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .SvgIcon */ .l, {
    name: "promotion",
    size: 16,
    color: "#1435c3"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("\u0110\xE3 \xE1p d\u1EE5ng m\xE3 gi\u1EA3m gi\xE1"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Coupon, null, " ", ((_a = promotion.condition) == null ? void 0 : _a.coupon) || "", " "), (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("gi\u1EA3m"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_PromotionInfo_PromotionInfo_es_js__WEBPACK_IMPORTED_MODULE_8__/* .PromotionInfo */ .z, {
    money: (_b = promotion.benefit.money) == null ? void 0 : _b[0],
    condition: promotion.condition || null
  })))), promotion.remainingTime && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Expired, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("Ch\u1EC9 c\xF2n"), " ", promotion.remainingTime)));
};




/***/ }),

/***/ 468382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ PromotionInfo; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(526439);




const Percent = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  margin-left: 4px;
`;
const StyledCurrency = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Currency */ .F)`
  margin: 0 4px;
  color: #ed2101;
  font-weight: 500;
`;
const OrderValueMin = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  margin-left: 4px;
`;
const OrderValueMax = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(Percent)``;
const PromotionInfo = ({
  money,
  condition
}) => {
  if (!money)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, money.discountType === "percent" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Percent, null, money.percent, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("% t\u1ED1i \u0111a"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, {
    value: money.maxDiscount || 0
  })) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, {
    value: money.money || 0
  }), condition && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, condition.orderValueMin && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OrderValueMin, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("cho \u0111\u01A1n h\xE0ng t\u1EEB"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Currency */ .F, {
    value: condition.orderValueMin
  })), condition.orderValueMax && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OrderValueMax, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("\u0111\u1EBFn"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Currency */ .F, {
    value: condition.orderValueMax
  }))));
};




/***/ }),

/***/ 23212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ OrderBy; },
/* harmony export */   "q": function() { return /* binding */ PromotionType; }
/* harmony export */ });
const PromotionType = {
  PRODUCT: "product",
  COUPON: "coupon"
};
var OrderBy = /* @__PURE__ */ ((OrderBy2) => {
  OrderBy2["ASC"] = "ASC";
  OrderBy2["DESC"] = "DESC";
  return OrderBy2;
})(OrderBy || {});




/***/ }),

/***/ 243290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ag": function() { return /* binding */ DescriptionCol; },
/* harmony export */   "DH": function() { return /* binding */ NotFoundProductLayout; },
/* harmony export */   "DY": function() { return /* binding */ StyledCurrency; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "TG": function() { return /* binding */ DefaultPromoContent; },
/* harmony export */   "Uv": function() { return /* binding */ FreeShipping; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "W": function() { return /* binding */ ProductVariantsWrapper; },
/* harmony export */   "Zb": function() { return /* binding */ Card; },
/* harmony export */   "__": function() { return /* binding */ Label; },
/* harmony export */   "bf": function() { return /* binding */ StyledProductPrice; },
/* harmony export */   "g$": function() { return /* binding */ RelatedPromotions; },
/* harmony export */   "hB": function() { return /* binding */ DefaultPromo; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "iz": function() { return /* binding */ Divider; },
/* harmony export */   "p3": function() { return /* binding */ ShippingInfo; },
/* harmony export */   "rU": function() { return /* binding */ Link; }
/* harmony export */ });
/* unused harmony exports BundleProductWrapper, BundleImage, BundleProductName, BundlePrice, ComboTitle, StyledPromotion, Stock, ModalAction, StyledProductNotes, WarningNote, DetailService */
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(469381);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(853675);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212808);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(591007);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  border-bottom: 1px dashed #e0e0e0;\n  margin: 1rem 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  background: white;\n  border-radius: 8px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  color: #53c305;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  margin-left: 8px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n\n  font-size: 0.75rem;\n  color: #333333;\n  text-decoration: none;\n  margin-top: 1rem;\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  width: 10%;\n  border-radius: 2px;\n  border: solid 1px #e0e0e0;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  margin-left: 18px;\n  width: 70%;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  font-weight: 500;\n  flex: 1;\n  text-align: right;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = _taggedTemplateLiteral([
        "\n  font-weight: bold;\n  font-size: 1rem;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: 0.5rem;\n  border-radius: 0.5rem;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = _taggedTemplateLiteral([
        "\n  li {\n    margin-bottom: 7px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = _taggedTemplateLiteral([
        "\n  font-weight: bold;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = _taggedTemplateLiteral([
        "\n  color: #ed2101;\n  font-weight: 500;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = _taggedTemplateLiteral([
        "\n  text-decoration: none;\n  margin-left: 4px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = _taggedTemplateLiteral([
        "\n  padding-left: 0 !important;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 12px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    const data = _taggedTemplateLiteral([
        "\n  color: #f78212;\n  font-size: 0.75rem;\n  margin: 0 0 0.5rem 0;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    const data = _taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    const data = _taggedTemplateLiteral([
        "\n  border: solid 1px #f78212;\n  border-radius: 4px;\n  color: #f78212;\n  padding: 10px 15px 0px 15px;\n  margin-top: 25px;\n  ol {\n    padding-left: 10px;\n    margin-bottom: 10px;\n  }\n  font-size: 12px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 16px;\n  border: solid 1px #f78212;\n  border-radius: 4px;\n  color: #f78212;\n  padding: 6px 8px;\n  font-size: 12px;\n  display: flex;\n  flex-direction: row;\n  .text {\n    flex: 1;\n    margin-left: 6px;\n    line-height: 1.5;\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    const data = _taggedTemplateLiteral([
        "\n  margin-left: 2rem;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 16px;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: #fbfbfd;\n  border: 1px solid #e4e5f0;\n  box-sizing: border-box;\n  border-radius: 8px;\n  padding: 8px 16px;\n  margin-top: 8px;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    const data = _taggedTemplateLiteral([
        "\n  min-height: 450px;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 1rem;\n  line-height: 1.5rem;\n  h2 {\n    font-size: 20px;\n    line-height: 1.4;\n  }\n  h3 {\n    font-size: 16px;\n    line-height: 1.3;\n  }\n  h4 {\n    font-size: 14px;\n  }\n  h5 {\n    font-size: 12px;\n  }\n  h6 {\n    font-size: 10px;\n  }\n  img {\n    height: auto;\n  }\n\n  > * {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}



const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject());
const Divider = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject1());
const ProductVariantsWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject2());
const Card = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject3());
const FreeShipping = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject4());
const ShippingInfo = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject5());
const Label = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div((param)=>{
    let { theme  } = param;
    return "\n  color: ".concat(theme.colors.textSecondary, ";\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  margin-bottom: 0.25rem;\n");
});
const BundleProductWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].a(_templateObject6());
const BundleImage = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject7());
const BundleProductName = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject8());
const BundlePrice = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject9());
const ComboTitle = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject10());
const StyledPromotion = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_1__/* .Promotion */ .L)(_templateObject11());
const RelatedPromotions = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject12());
const Title = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject13());
const StyledCurrency = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Currency */ .F)(_templateObject14());
const Link = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].a(_templateObject15());
const DescriptionCol = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .JX)(_templateObject16());
const StyledProductPrice = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"])(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__/* .ProductPrice */ .j)(_templateObject17());
const Stock = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject18());
const ModalAction = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject19());
const StyledProductNotes = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject20());
const WarningNote = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject21());
const DetailService = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].a(_templateObject22());
const DefaultPromo = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject23());
const DefaultPromoContent = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject24());
const NotFoundProductLayout = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject25());
const Content = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject26());


/***/ })

}]);